export default "__VITE_PUBLIC_ASSET__af53eef5__"